import {BadgePlatform} from '@yandex-data-ui/common';
import {GridColumnSize} from '@yandex-data-ui/page-constructor';

import {Env} from 'contexts/EnvContext';
import {FeatureFlags} from 'contexts/FeatureFlagsContext';
import {Locale} from 'contexts/LocaleContext';
import {I18nFunction} from 'i18n';
import {
    CategoryData,
    NavigationItemExtended,
    ServicesByCategory,
    SolutionByCategory,
} from 'models/app';
import {DropdownTypes} from './config/constants';
import {NavigationItemBlockSize} from 'units/constructor-local/models';

export enum LoadableItems {
    Mkt = 'mkt',
}

export enum NavigationItemType {
    Default = 'default',
    DefaultWithImg = 'default-with-img',
    Link = 'link',
    ArrowLink = 'arrow-link',
    Button = 'button',
    Service = 'service',
    Social = 'social',
}

export enum NavigationSectionType {
    Services = 'services',
    Solutions = 'solutions',
}

export type NavigationConfig = NavigationSection[];

export interface NavigationSection {
    title: string;
    url?: string;
    type?: NavigationSectionType;
    isFullscreen?: boolean;
    columns?: NavigationColumn[];
    footer?: NavigationItem[];
    dropdown?: DropdownTypes;
}

export interface NavigationColumn {
    groups: NavigationColumnGroup[];
    colspan?: 2 | 3;
    footer?: NavigationColumnGroup[];
    title?: string;
}

export interface NavigationFooterColumnGroup {
    title: string;
    items: NavigationItem[];
}

export interface NavigationColumnGroup {
    items: NavigationItem[];
    title?: NavigationItem;
    url?: string;
}

export interface NavigationItem {
    title: string;
    url: string;
    type?: NavigationItemType;
    description?: string;
    icon?: string;
    blank?: boolean;
    goal?: string;
}

export interface NavigationGroupMobile {
    items: NavigationItem[];
    title: string;
    footer?: NavigationItem[];
}

export interface NavigationStoreBadgeItem {
    platform: BadgePlatform;
    url: string;
    goal: string;
}

export interface NavigationStoreBadges {
    title: string;
    items: NavigationStoreBadgeItem[];
}

export type NavigationSectionMobile = NavigationGroupMobile | NavigationItem;
export type NavigationConfigMobile = NavigationSectionMobile[];

export interface ConfigParams {
    env: Env;
    i18n: I18nFunction;
    locale: Locale;
    isAuthorized: boolean;
    featureFlags: FeatureFlags;
}

export interface ShortConfigParams extends Omit<ConfigParams, 'isAuthorized'> {
    serviceCategories: CategoryData[];
    solutionCategories: CategoryData[];
}

export type NavigationFooterConfig = {
    columns: NavigationFooterColumnGroup[][];
    footer: NavigationItem[];
    social: NavigationItem[];
    mobileStores: NavigationStoreBadges;
};

export type ConfigServiceGroup = Record<string, NavigationColumnGroup>;

export const DefaultCategorizedItemSizes = {
    [GridColumnSize.Lg]: 4,
    [GridColumnSize.Sm]: 6,
    [GridColumnSize.All]: 12,
};

export interface List {
    navigationItems: NavigationItemExtended[];
    type: NavigationSectionType;
}

export interface Category {
    category: CategoryData;
}

export interface Location {
    location?: 'page' | 'popup';
}

export interface ItemsProps extends Location {
    categories: CategoryData[];
    dataByCategory: ServicesByCategory | SolutionByCategory;
    size: NavigationItemBlockSize;
}
